import { Flex, IconProps } from '@chakra-ui/react';

import { Divider } from 'uiToolkitV1/Divider';
import { TextBodyLarge, TextLabel } from 'uiToolkitV1/Typography';

export const Container = ({
  title,
  description,
  children,
  icon,
}: {
  title: string;
  description: string;
  children: React.ReactNode;
  icon: React.FC<IconProps>;
}) => {
  const Icon = icon;

  return (
    <Flex flexDir="column" bgColor="#ffffff" boxShadow="0px 2px 8px 0px rgba(0, 0, 0, 0.08)" p={4} borderRadius="8px">
      <Flex alignItems="center">
        <Icon boxSize="24px" color="text.g2" />
        <Flex ml={2} flexDir="column">
          <TextBodyLarge bold>{title}</TextBodyLarge>
          <TextLabel>{description}</TextLabel>
        </Flex>
      </Flex>
      <Divider mt={4} borderColor="#CFD7DF" />
      {children}
    </Flex>
  );
};
